import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';

import { cn } from '../../../utils/tailwindMerge';

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ');
}

const Dropdown = ({
  options,
  label,
  isRequired,
  handleDropdownChange,
  value,
  getOption,
  shouldHideOptions,
  openState,
  width,
  placeholder,
  disable,
  classes,
  optionWidth
}: {
  options: any;
  label?: string;
  isRequired?: boolean;
  handleDropdownChange: (value: any, index?: number) => void;
  value: string | number;
  getOption: any;
  shouldHideOptions?: boolean;
  openState?: boolean;
  width?: string;
  placeholder?: string;
  disable?: boolean;
  classes?: string;
  optionWidth?: string;
}) => {
  return (
    <Menu as='div'>
      <p className='block text-sm font-semibold leading-6'>
        {label} {isRequired && <span className='text-[red]'>*</span>}
      </p>
      <div className={`relative mt-[6px] ${width}`}>
        <MenuButton
          className={cn([
            'relative h-9 cursor-pointer rounded-md border border-[#E3E5E9] bg-white py-1.5 pl-3 pr-10 text-left text-blue_a12 sm:text-sm sm:leading-6',
            width ?? 'w-1/2',
            disable && 'cursor-not-allowed',
            classes ??
              'shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none'
          ])}
        >
          <span className='flex items-center'>
            <span className='ml-3 block truncate text-base'>
              {value || placeholder}
            </span>
          </span>
          <span className='pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2'>
            {openState ? (
              <IoIosArrowUp className='h-5 w-5' aria-hidden='true' />
            ) : (
              <IoIosArrowDown className='h-5 w-5' aria-hidden='true' />
            )}
          </span>
        </MenuButton>

        <div>
          <MenuItems
            transition
            className={cn([
              'absolute z-50 mt-1 max-h-56 min-w-fit origin-top-right overflow-auto rounded-xl border border-white/5 bg-white text-base text-blue_a12 shadow-lg ring-1 ring-black ring-opacity-5 transition duration-100 ease-out [--anchor-gap:var(--spacing-1)] focus:outline-none focus:outline-none data-[closed]:scale-95 data-[closed]:opacity-0 sm:text-sm',
              width ?? 'w-1/2'
            ])}
          >
            {options.map((option: any) => {
              return (
                <MenuItem key={option.id}>
                  <button
                    onClick={() => handleDropdownChange(option)}
                    className={cn([
                      'group flex justify-between px-4 py-2 text-base data-[focus]:bg-[#3F5DD9] data-[focus]:text-alpha ',
                      optionWidth ?? 'w-full'
                    ])}
                  >
                    {getOption(option, classNames)}
                  </button>
                </MenuItem>
              );
            })}
          </MenuItems>
        </div>
      </div>
    </Menu>
  );
};

export default Dropdown;
